export default "__VITE_ASSET__hY31im2i__"